// plasma-research-init.js — wires the new research-grade plasma forms,
// applies RBAC gating via auth.js (matching the existing plasma-tabs pattern),
// and renders the validation table on first open.

// Gating is handled by plasma-tabs.js::applyLicenseGating() which is
// the canonical path called from app.js after auth. This module only
// wires form submissions + the validation-table on-demand load.

import {
  initResearch, runSoloviev, runBallooning, runMercier, runMultiMode,
  runSensitivity, runConvergence, importEFIT, renderValidationTable
} from './plasma-research.js';

const RESEARCH_PANELS = [
  { form: 'f-soloviev', handler: runSoloviev },
  { form: 'f-balloon', handler: runBallooning },
  { form: 'f-mercier', handler: runMercier },
  { form: 'f-multimode', handler: runMultiMode },
  { form: 'f-sens', handler: runSensitivity },
  { form: 'f-conv', handler: runConvergence },
];

function bindForm(formId, handler) {
  const form = document.getElementById(formId);
  if (!form) return;
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('.btn-primary');
    if (btn) btn.disabled = true;
    try { handler(e.target); }
    catch (err) { console.error(`[${formId}]`, err); }
    finally { if (btn) btn.disabled = false; }
  });
}

async function bootstrap() {
  await initResearch();
  for (const p of RESEARCH_PANELS) bindForm(p.form, p.handler);

  const efitForm = document.getElementById('f-efit');
  if (efitForm) {
    efitForm.addEventListener('submit', e => e.preventDefault());
    const input = document.getElementById('efit-file-input');
    const drop = efitForm.querySelector('.efit-drop');
    const handleFile = async (file) => {
      if (!file) return;
      const status = document.getElementById('s-efit');
      if (status) status.textContent = `Loading ${file.name}…`;
      await importEFIT(file);
    };
    if (input) input.addEventListener('change', ev => handleFile(ev.target.files?.[0]));
    if (drop) {
      ['dragenter', 'dragover'].forEach(ev => drop.addEventListener(ev, e => {
        e.preventDefault(); e.stopPropagation(); drop.classList.add('drag-over');
      }));
      ['dragleave', 'drop'].forEach(ev => drop.addEventListener(ev, e => {
        e.preventDefault(); e.stopPropagation(); drop.classList.remove('drag-over');
      }));
      drop.addEventListener('drop', e => {
        const file = e.dataTransfer?.files?.[0];
        if (file) handleFile(file);
      });
    }
  }

  const validationTab = document.querySelector('.ptab[data-pt="validation"]');
  if (validationTab) {
    let loaded = false;
    validationTab.addEventListener('click', async () => {
      if (!loaded) { await renderValidationTable(); loaded = true; }
      // Auto-rerun on every tab open after the first — keeps stale results from lingering
      else { window.gdbsRerunAllValidation?.(); }
    });
  }

  // No gating here — plasma-tabs.js::applyLicenseGating handles it.
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
